// src/components/Milestone.js
import React, { forwardRef, useEffect, useState } from "react";
import { Box, Chip, Grid2, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Skeleton, Tooltip } from "@mui/material";
import moment from "moment";
import alignCenter from "assets/icons/aligncenter.svg";
import { useGetAllMilestoneQuery } from '../../../store/slices/apis/milestoneDashboardSlice';
import { useParams } from "react-router-dom";
import { PiDiamondDuotone } from "react-icons/pi";


const RefForwardedDiamondIcon = forwardRef(function Icon(props, ref) {
    return (
        <Tooltip
            placement="top"
            title={props?.title}
            enterTouchDelay={0}    // show immediately on touch
            arrow
            slotProps={{
                tooltip: { sx: { fontSize: "12px" } },
            }}
        >
            <span ref={ref}>
                <PiDiamondDuotone
                    style={{
                        height: "20px",
                        width: "20px",
                        color: props?.color,
                        strokeWidth: 12,
                    }}
                    {...props}
                />
            </span>
        </Tooltip>
    );
});

const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '14px', color: '#37352F', padding: '10px 14px 10px 14px'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000', padding: '10px 14px 10px 14px',
    border: 'none'
}));

const StyledTableHeadings = styled(TableCell)(({ theme }) => ({
    whiteSpace: 'nowrap',
    fontWeight: 500,
    lineHeight: '115.99999999999999%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    color: '#4c4c6699',
    padding: '10px',
    border: 0,
    position: 'static !important',
    [theme.breakpoints.up('md')]: {
        position: 'sticky !important',
    }
}));

const StyledTableData = styled(TableCell)(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '115.99999999999999%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    color: '#4C4C66',
    padding: '10px',
    border: 0,
    position: 'static !important',
    [theme.breakpoints.up('md')]: {
        position: 'sticky !important',
    }
}));

const cellWidth = 65;
const rowHeight = 40;

const Milestone = () => {

    const { projectId } = useParams();
    const [months, setMonths] = useState([]);
    const [milestoneList, setMilestoneList] = useState([]);
    const { data: allMileStoneData, isSuccess, isError, isLoading, error } = useGetAllMilestoneQuery(projectId);

    useEffect(() => {
        if (isSuccess) {
            const allDates = allMileStoneData?.data?.flatMap(item => [
                item.plan_date ? moment(item.plan_date) : null,
                item.forecast_date ? moment(item.forecast_date) : null,
                item.actual_date ? moment(item.actual_date) : null
            ])
                .filter(date => date && date.isValid());

            const startMonth = moment.min(allDates).startOf('month');
            const endMonth = moment.max(allDates).endOf('month');

            // console.log("Min:", minDates.format("YYYY-MM-DD"), "Max:", maxDates.format("YYYY-MM-DD"));


            const minDate = new Date(
                Math.min(...allMileStoneData?.data.map(task => new Date(task?.plan_date)))
            );
            const maxDate = new Date(
                Math.max(...allMileStoneData?.data.map(task => new Date(task?.plan_date)))
            );


            // const startMonth = moment(minDate).startOf('month');
            // const endMonth = moment(maxDate).endOf('month');

            const month = [];
            let current = startMonth.clone();

            while (current.isSameOrBefore(endMonth, 'month')) {
                month.push(current.format('MMM YY'));
                current.add(1, 'month');
            }
            // console.log(month);

            setMonths(month);
            const sortedMilestones = [...allMileStoneData?.data]?.sort((a, b) =>
                moment(a?.plan_date).diff(moment(b?.plan_date))
            );


            setMilestoneList(sortedMilestones)

        }
    }, [isSuccess])

    const renderMilestone = (task) => {
        if (task?.actual_date) {
            if (moment(task?.actual_date).isSame(task?.plan_date)) {
                return (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1
                    }}>
                        <RefForwardedDiamondIcon color='green' title={`Baseline Date: ${moment(task?.plan_date)?.format('MMM DD, YYYY')}`} />
                    </Box>
                )
            } else if (moment(task?.actual_date).isAfter(task?.plan_date)) {
                return (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1
                    }}>
                        {/* <Tooltip
                            placement="top"
                            title={`Baseline Date: ${moment(task.plan_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        > */}
                        {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#415385',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        <RefForwardedDiamondIcon color='#415385' title={`Baseline Date: ${moment(task?.plan_date)?.format('MMM DD, YYYY')}`} />
                        {/* </Tooltip> */}
                        <Box sx={{
                            border: '2px dotted',
                            borderColor: "#444444",
                            flexGrow: 1
                        }} />
                        {/* <Tooltip
                            placement="top"
                            title={`Actual Date: ${moment(task.actual_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        > */}
                        <RefForwardedDiamondIcon color='#C84757' title={`Actual Date: ${moment(task?.actual_date)?.format('MMM DD, YYYY')}`} />
                        {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#C84757',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        {/* </Tooltip> */}
                    </Box>
                )
            } else {
                return (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1
                    }}>


                        {/* <Tooltip
                            placement="top"
                            title={`Actual Date: ${moment(task.actual_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        > */}
                        <RefForwardedDiamondIcon color='#415385' title={`Actual Date: ${moment(task?.actual_date)?.format('MMM DD, YYYY')}`} />
                        {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#415385',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        {/* </Tooltip> */}
                        <Box sx={{
                            border: '2px dotted',
                            borderColor: "#444444",
                            flexGrow: 1
                        }} />
                        {/* <Tooltip
                            placement="top"
                            title={`Baseline Date: ${moment(task.plan_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        > */}
                        {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: 'green',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        <RefForwardedDiamondIcon color='green' title={`Baseline Date: ${moment(task?.plan_date)?.format('MMM DD, YYYY')}`} />
                        {/* </Tooltip> */}
                    </Box>
                )
            }

        } else {
            if (moment(task?.forecast_date).isSame(task?.plan_date)) {
                return (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1
                    }}>
                        <Tooltip
                            placement="top"
                            title={`Baseline Date: ${moment(task.plan_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: 'green',
                                    strokeWidth: 12,
                                }}
                            /> */}
                            <RefForwardedDiamondIcon color='green' />
                        </Tooltip>
                    </Box>
                )
            } else if (moment(task?.forecast_date).isAfter(task?.plan_date)) {
                return (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1
                    }}>
                        <Tooltip
                            placement="top"
                            title={`Baseline Date: ${moment(task?.plan_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            <RefForwardedDiamondIcon color='#415385' />
                            {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#415385',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        </Tooltip>
                        <Box sx={{
                            border: '2px dotted',
                            borderColor: "#444444",
                            flexGrow: 1
                        }} />
                        <Tooltip
                            placement="top"
                            title={`Forecast Date: ${moment(task?.forecast_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            <RefForwardedDiamondIcon color='#C84757' />
                            {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#C84757',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        </Tooltip>
                    </Box>
                )
            } else {
                return (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 1
                    }}>
                        <Tooltip
                            placement="top"
                            title={`Baseline Date: ${moment(task?.plan_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            <RefForwardedDiamondIcon color='#415385' />
                            {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#415385',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        </Tooltip>
                        <Box sx={{
                            border: '2px dotted',
                            borderColor: "#444444",
                            flexGrow: 1
                        }} />
                        <Tooltip
                            placement="top"
                            title={`Forecast Date: ${moment(task?.forecast_date)?.format('MMM DD, YYYY')}`}
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            <RefForwardedDiamondIcon color='#415385' />
                            {/* <PiDiamondDuotone
                                style={{
                                    height: '20px', width: '20px', color: '#415385',
                                    strokeWidth: 12,
                                }}
                            /> */}
                        </Tooltip>
                    </Box>
                )
            }
        }
    };

    if (isLoading) {
        return (
            <>
                <Box sx={{ padding: '40px 10px 10px 20px', background: "#fff", borderRadius: 2, mb: 3 }}>
                    <Skeleton variant="rectangular" width="100%" height={400} />
                </Box>
                <Paper sx={{ boxShadow: 'none' }}>
                    <Box display="flex" alignItems="center" sx={{ padding: '16px' }}>
                        <Skeleton variant="circular" width={24} height={24} />
                        <Skeleton variant="text" width={180} height={24} sx={{ marginLeft: 2 }} />
                    </Box>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {[...Array(4)].map((_, i) => (
                                        <StyledTableHead key={i}>
                                            <Skeleton variant="text" width={100} height={20} />
                                        </StyledTableHead>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[...Array(5)].map((_, rowIdx) => (
                                    <TableRow key={rowIdx}>
                                        {[...Array(4)].map((_, colIdx) => (
                                            <StyledTableRow key={colIdx}>
                                                <Skeleton variant="text" width={colIdx === 0 ? "700px" : "100%"} height={20} />
                                            </StyledTableRow>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </>
        );
    }

    if (milestoneList?.length > 0)
        return (
            <>
                <Box sx={{ padding: '40px 10px 10px 20px', background: "#fff", borderRadius: 2, mb: 3, overflowX: 'auto', maxWidth: '100%' }}>
                    <TableContainer component={Paper}
                        sx={{
                            overflowX: 'auto',
                            position: 'relative'
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHeadings style={{
                                        left: 0,
                                        background: '#fff',
                                        zIndex: 2,
                                        minWidth: 70
                                    }}>Sl no.</StyledTableHeadings>
                                    <StyledTableHeadings style={{
                                        left: 70,
                                        background: '#fff',
                                        zIndex: 2,
                                        minWidth: 160
                                    }}>Milestone</StyledTableHeadings>
                                    <StyledTableHeadings
                                        style={{
                                            left: 230,
                                            background: '#fff',
                                            zIndex: 2,
                                            minWidth: 60
                                        }}
                                    >Baseline Date</StyledTableHeadings>
                                    <StyledTableHeadings
                                        style={{
                                            left: 335,
                                            background: '#fff',
                                            zIndex: 2,
                                            minWidth: 60
                                        }}
                                    >Forecast / Actual Date</StyledTableHeadings>
                                    {months.map(month => (
                                        <TableCell key={month} align="center"
                                            sx={{
                                                minWidth: cellWidth,
                                                fontSize: '12px',
                                                fontWeight: 500,
                                                lineHeight: '115.99999999999999%',
                                                letterSpacing: '0%',
                                                verticalAlign: 'middle',
                                                color: '#9392A2',
                                                padding: '10px',
                                                border: 0
                                            }}
                                        >{month}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {milestoneList?.map((task, rowIndex) => {
                                    // console.log(task);
                                    // let milestoneData;
                                    // if (task?.actual_date) {
                                    //     milestoneData =  

                                    // } else {
                                    //     console.log('a');
                                    // }
                                    // const startIndex = months.indexOf(moment(task.plan_date)?.format('YYYY-MM'));
                                    // const endIndex = months.indexOf(moment(task.plan_date)?.format('YYYY-MM'));
                                    // const startX = (startIndex + 1) * cellWidth + cellWidth / 2;
                                    // const endX = (endIndex + 1) * cellWidth + cellWidth / 2;
                                    // const y = rowIndex * rowHeight + rowHeight / 2 + 25;

                                    return (
                                        <TableRow key={rowIndex}
                                            sx={{
                                                position: 'relative',
                                                '&:nth-of-type(odd)': {
                                                    backgroundColor: '#EDEDED',
                                                    color: '#fff',
                                                }
                                            }}
                                        >
                                            <StyledTableData
                                                style={{
                                                    left: 0,
                                                    zIndex: 2,
                                                    minWidth: 30,
                                                    backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff', // Match TableRow background
                                                }}
                                            >{rowIndex + 1}</StyledTableData>
                                            <StyledTableData
                                                style={{
                                                    left: 70,
                                                    zIndex: 2,
                                                    minWidth: 160,
                                                    backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff', // Match TableRow background
                                                }}
                                            >{task?.milestone_name}</StyledTableData>
                                            <StyledTableData
                                                style={{
                                                    left: 230,
                                                    zIndex: 2,
                                                    minWidth: 60,
                                                    backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff', // Match TableRow background
                                                    color: '#9392A2',
                                                }}
                                            >{moment(task?.plan_date).format('MMM DD,YYYY')}</StyledTableData>
                                            <StyledTableData
                                                style={{
                                                    left: 335,
                                                    zIndex: 2,
                                                    minWidth: 60,
                                                    backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff',
                                                    color: '#9392A2',
                                                }}
                                            >
                                                {task?.actual_date ?
                                                    moment(task?.actual_date).format('MMM DD,YYYY')
                                                    : moment(task?.forecast_date).format('MMM DD,YYYY')
                                                }

                                            </StyledTableData>
                                            {months.map((month, colIndex) => {

                                                if (task?.actual_date) {
                                                    if (task?.actual_date && moment(task?.actual_date).isBefore(task?.plan_date)) {
                                                        var startIndex = months.indexOf(moment(task.actual_date)?.format('MMM YY'));
                                                        var endIndex = months.indexOf(moment(task.plan_date)?.format('MMM YY'));

                                                    } else {
                                                        var startIndex = months.indexOf(moment(task.plan_date)?.format('MMM YY'));
                                                        var endIndex = months.indexOf(moment(task.actual_date)?.format('MMM YY'));
                                                    }

                                                } else {

                                                    var startIndex = months.indexOf(moment(task.plan_date)?.format('MMM YY'));
                                                    var endIndex = months.indexOf(moment(task.forecast_date)?.format('MMM YY'));
                                                }

                                                // if (task?.actual_date && moment(task?.actual_date).isBefore(task?.plan_date)) {
                                                //     var startIndex = months.indexOf(moment(task.actual_date)?.format('MMM YY'));
                                                //     var endIndex = months.indexOf(moment(task.plan_date)?.format('MMM YY'));

                                                // } else {
                                                //     var startIndex = months.indexOf(moment(task.plan_date)?.format('MMM YY'));
                                                // }




                                                const colSpan = endIndex - startIndex + 1;

                                                if (colIndex === startIndex) {
                                                    return (
                                                        <TableCell
                                                            key={colIndex}
                                                            align="center"
                                                            colSpan={colSpan}
                                                            sx={{ position: 'relative', minWidth: cellWidth, padding: '0px', border: 0 }}
                                                        >
                                                            {renderMilestone(task)}

                                                            {/* <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                px: 1
                                                            }}>
                                                                <Tooltip
                                                                    placement="top"
                                                                    title={`Baseline Date: ${moment(task.plan_date)?.format('MMM YY')}`}
                                                                    arrow
                                                                    slotProps={{
                                                                        tooltip: { sx: { fontSize: "12px" } },
                                                                    }}
                                                                >
                                                                    <PiDiamondDuotone
                                                                        style={{
                                                                            height: '20px', width: '20px', color: '#415385',
                                                                            strokeWidth: 12,
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                                <Box sx={{
                                                                    border: '2px dotted',
                                                                    borderColor: "#444444",
                                                                    flexGrow: 1
                                                                }} />
                                                                <Tooltip
                                                                    placement="top"
                                                                    title={`Forecast Date: ${moment(task.plan_date)?.format('MMM YY')}`}
                                                                    arrow
                                                                    slotProps={{
                                                                        tooltip: { sx: { fontSize: "12px" } },
                                                                    }}
                                                                >
                                                                    <PiDiamondDuotone
                                                                        style={{
                                                                            height: '20px', width: '20px', color: '#C84757',
                                                                            strokeWidth: 12,
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </Box> */}
                                                        </TableCell>
                                                    );
                                                }

                                                // Skip all the columns that are within the colSpan
                                                if (colIndex > startIndex && colIndex <= endIndex) {
                                                    return null;
                                                }

                                                // Render empty cells before startMonth or after endMonth
                                                return (
                                                    <TableCell key={colIndex} align="center" sx={{ height: rowHeight, padding: '0px', border: 0 }}>
                                                        {/* Empty cell */}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* <HighchartsReact highcharts={Highcharts} constructorType={"ganttChart"} options={chartOptions} /> */}


                </Box>
                <Paper sx={{ boxShadow: 'none' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHead colSpan={4}>
                                        <Box display="flex" alignItems="center">
                                            <IconButton>
                                                <img src={alignCenter} style={{
                                                    height: '14px',
                                                    width: '14px'
                                                }} />
                                            </IconButton>
                                            <Typography variant="h6"
                                                sx={{
                                                    fontWeight: '400',
                                                    fontSize: '14px',
                                                    color: '#000000'
                                                }}
                                            >Milestone List</Typography>
                                        </Box>
                                    </StyledTableHead>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHead sx={{ width: '60%' }} style={{ padding: '10px 14px 10px 35px' }}>Milestone</StyledTableHead>
                                    <StyledTableHead>Baseline</StyledTableHead>
                                    <StyledTableHead>Forecast Completion</StyledTableHead>
                                    <StyledTableHead>Actual Date</StyledTableHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {milestoneList?.map((row, index) => (
                                    <TableRow key={index}>
                                        <StyledTableRow style={{ padding: '10px 14px 10px 35px' }}>{row.milestone_name}</StyledTableRow>
                                        <StyledTableRow>{moment(row.plan_date).format("MMM D, YYYY")}</StyledTableRow>
                                        <StyledTableRow>{moment(row.forecast_date).format("MMM D, YYYY")}</StyledTableRow>
                                        <StyledTableRow>{row?.actual_date ? moment(row.actual_date).format("MMM D, YYYY") : ""}</StyledTableRow>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </>
        );
    else
        return (
            <>
                <Box sx={{ padding: '40px 10px 10px 20px', background: "#fff", borderRadius: 2, mb: 3, overflowX: 'auto', maxWidth: '100%' }}>
                    <TableContainer component={Paper} sx={{ overflowX: 'auto', position: 'relative' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHeadings style={{ left: 0, background: '#fff', zIndex: 2, minWidth: 70 }}>Sl no.</StyledTableHeadings>
                                    <StyledTableHeadings style={{ left: 70, background: '#fff', zIndex: 2, minWidth: 160 }}>Milestone</StyledTableHeadings>
                                    <StyledTableHeadings style={{ left: 230, background: '#fff', zIndex: 2, minWidth: 60 }}>Baseline Date</StyledTableHeadings>
                                    <StyledTableHeadings style={{ left: 335, background: '#fff', zIndex: 2, minWidth: 60 }}>Forecast / Actual Date</StyledTableHeadings>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {milestoneList?.length > 0 ? (
                                    milestoneList.map((task, rowIndex) => (
                                        <TableRow key={rowIndex} sx={{ position: 'relative', '&:nth-of-type(odd)': { backgroundColor: '#EDEDED' } }}>
                                            <StyledTableData style={{ left: 0, zIndex: 2, minWidth: 30, backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff' }}>
                                                {rowIndex + 1}
                                            </StyledTableData>
                                            <StyledTableData style={{ left: 70, zIndex: 2, minWidth: 160, backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff' }}>
                                                {task?.milestone_name}
                                            </StyledTableData>
                                            <StyledTableData style={{ left: 230, zIndex: 2, minWidth: 60, backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff', color: '#9392A2' }}>
                                                {moment(task?.plan_date).format('MMM DD,YYYY')}
                                            </StyledTableData>
                                            <StyledTableData style={{ left: 335, zIndex: 2, minWidth: 60, backgroundColor: rowIndex % 2 === 0 ? '#EDEDED' : '#fff', color: '#9392A2' }}>
                                                {task?.actual_date ? moment(task?.actual_date).format('MMM DD,YYYY') : moment(task?.forecast_date).format('MMM DD,YYYY')}
                                            </StyledTableData>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={months.length + 4} align="center" sx={{ height: 200, color: "#9E9E9E", fontSize: "16px" }}>
                                            No record found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Paper sx={{ boxShadow: 'none' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHead colSpan={4}>
                                        <Box display="flex" alignItems="center">
                                            <IconButton>
                                                <img src={alignCenter} style={{ height: '14px', width: '14px' }} />
                                            </IconButton>
                                            <Typography variant="h6" sx={{ fontWeight: '400', fontSize: '14px', color: '#000000' }}>
                                                Milestone List
                                            </Typography>
                                        </Box>
                                    </StyledTableHead>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHead sx={{ width: '60%' }} style={{ padding: '10px 14px 10px 35px' }}>Milestone</StyledTableHead>
                                    <StyledTableHead>Baseline</StyledTableHead>
                                    <StyledTableHead>Forecast Completion</StyledTableHead>
                                    <StyledTableHead>Actual Date</StyledTableHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {milestoneList?.length > 0 ? (
                                    milestoneList.map((row, index) => (
                                        <TableRow key={index}>
                                            <StyledTableRow style={{ padding: '10px 14px 10px 35px' }}>{row.milestone_name}</StyledTableRow>
                                            <StyledTableRow>{moment(row.plan_date).format("MMM D, YYYY")}</StyledTableRow>
                                            <StyledTableRow>{moment(row.forecast_date).format("MMM D, YYYY")}</StyledTableRow>
                                            <StyledTableRow>{row?.actual_date ? moment(row.actual_date).format("MMM D, YYYY") : ""}</StyledTableRow>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center" sx={{ height: 100, color: "#9E9E9E", fontSize: "16px" }}>
                                            No record found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </>
        );
};

export default Milestone;